import Head from 'next/head';
import { useRouter } from 'next/router';
import { buildCanonical } from './url';

export default function SiteHead({ pagina, allDataHome, canonicalHost } : { pagina: any, allDataHome?: any, canonicalHost?: string }) {
  const router = useRouter();
  const site = allDataHome?.site;

  const runtimeHost = typeof window !== 'undefined' ? window.location.host : '';
  const host = canonicalHost || site?.site || runtimeHost;
  const canonicalUrl = buildCanonical(host, router.asPath || '/');
  const baseUrl = buildCanonical(host, '/').replace(/\/$/, '');

  const activeBanners = allDataHome?.allBanners.filter((item: { ativo: boolean; }) => item.ativo);
  const logoImage = site?.url_logo ? `${site?.url_logo}?v=${site?.contador_marca || 0}` : site?.url_icon;
  const ogImage = site?.id == 2558 && logoImage ? `${baseUrl}/api/og-image?url=${encodeURIComponent(logoImage)}&bg=black` : site?.id == 2204 ? site?.url_icon : site?.id == 1899 ? "https://imob.sobressai.com.br/Banner/1899/11879.jpg" : site?.id == 1616 ? "https://imob.sobressai.com.br/Banner/1616/11880.jpg" : activeBanners?.[0]?.url || logoImage;

  const tiposImoveis = allDataHome?.tipos.map((tipo: { nome: string; }) => tipo.nome).join(', ');
  const cidades = allDataHome?.cidades.map((cidade: { nome: string; }) => cidade.nome).join(', ');
  const transacoes = site?.transacoes.join(' e ');

  const nomeEmpresa = site?.Dados?.empresa || 'Imobiliária';

  const defaultTitle =
    site?.titulo || `${nomeEmpresa} - Imóveis em ${cidades}`;

  const defaultDescription =
    site?.meta_description ||
    `Encontre ${tiposImoveis} para ${transacoes} nas regiões de ${cidades}. Atendimento personalizado, documentação 100% online e aprovação rápida. Fale com a ${nomeEmpresa}!`;

  const keywords =
    site?.meta_keywords ||
    `imóveis, imobiliária, ${cidades}, ${transacoes}, ${tiposImoveis}`;

  return (
    <Head>
      <title>{defaultTitle}</title>
      <meta name="description" content={defaultDescription} />
      <meta name="keywords" content={keywords} />

      <meta property="og:title" content={defaultTitle} />
      <meta property="og:description" content={defaultDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content={pagina === 'home' ? 'website' : 'article'} />
      <link rel="canonical" href={canonicalUrl} key="canonical" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={defaultTitle} />
      <meta name="twitter:description" content={defaultDescription} />
      <meta name="twitter:image" content={ogImage} />

      {site?.url_icon ? <link rel="icon" href={site.url_icon} /> : null}
      <link rel="dns-prefetch" href="https://fotos.sobressai.com.br" />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": site?.Dados?.empresa || "",
            "image": `${site?.url_logo}?v=${site?.contador_marca || 0}` || "",
            "url": baseUrl || canonicalUrl,
            "telephone": site?.Dados?.tel1 || "",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": site?.Dados?.endereco || "",
              "addressLocality": site?.Dados?.cidade || "",
              "addressRegion": site?.Dados?.estado || "",
              "postalCode": site?.Dados?.cep || "",
              "addressCountry": "BR"
            },
            "sameAs": [
              site?.Dados?.facebook || "",
              site?.Dados?.instagram || "",
              site?.Dados?.youtube || "",
            ].filter(Boolean)
          })
        }}
      />
    </Head>
  );
}
